import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const layoutClasses =
  'eye:inline-flex eye:items-center eye:justify-center eye:gap-2xs eye:rounded-md eye:px-2xs eye:rounded-md eye:border eye:border-grey-20 eye:enabled:hover:bg-grey-20 eye:aria-disabled:hover:bg-transparent eye:data-[disabled]:hover:bg-transparent';

const interactionClasses = 'eye:cursor-pointer eye:transition-colors';

const focusClasses =
  'eye:outline-offset-3 eye:outline-black eye:focus-visible:outline-2 eye:focus-visible:outline-black';

const disabledStateClasses =
  'eye:disabled:cursor-not-allowed eye:disabled:text-grey-disabled! eye:disabled:border-grey-20! eye:disabled:aria-pressed:bg-grey-disabled! eye:disabled:aria-checked:bg-grey-disabled! eye:aria-disabled:cursor-not-allowed eye:aria-disabled:aria-pressed:bg-grey-disabled! eye:aria-disabled:aria-checked:bg-grey-disabled! eye:data-[disabled]:cursor-not-allowed eye:data-[disabled]:aria-pressed:bg-grey-disabled! eye:data-[disabled]:aria-checked:bg-grey-disabled!';

const iconClasses =
  'eye:[&_svg]:pointer-events-none eye:[&_svg]:size-[24px] eye:[&_svg]:shrink-0';

const toggledStateClasses =
  'eye:aria-pressed:bg-blue-100 eye:aria-pressed:border-blue-100 eye:aria-pressed:hover:bg-blue-150 eye:aria-pressed:hover:border-blue-150  eye:aria-pressed:text-white eye:aria-checked:bg-blue-100 eye:aria-checked:border-blue-100 eye:aria-checked:hover:bg-blue-150 eye:aria-checked:hover:border-blue-150 eye:aria-checked:text-white';

const baseClasses = cn(
  layoutClasses,
  interactionClasses,
  focusClasses,
  disabledStateClasses,
  iconClasses,
);

export const toggleVariants = cva(cn(baseClasses, toggledStateClasses), {
  variants: {
    size: {
      default: 'eye:h-[44px] eye:min-w-[44px]',
      sm: 'eye:h-[35px] eye:min-w-[35px]',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
